import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/app/(Guest)/blogs/(main)/components/Blogs.jsx");
